import { Size } from '@ps/web-core-store';
import classNames from 'clsx';
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import useBonusGameResolver from '@swf/core/hooks/useBonusGameResolver';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import styles from './CasinoGameOverlay.scss';

interface CasinoGameOverlayParams {
  title: string;
  gameUrl: string;
  query: object;
}

const CasinoGameOverlay: React.FC = () => {
  const { title, gameUrl, query } = useSearchParams<CasinoGameOverlayParams>();
  const { setStyle } = useContext(ModalContext);
  const isMobile = useSelector(select.device.isMobile);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { modal } = useDispatch<Dispatch>();
  const url = useBonusGameResolver(gameUrl, query);

  const closeClick = () =>
    iframeRef?.current?.contentWindow &&
    iframeRef.current.contentWindow.postMessage('starsbeforeclose', window.origin);

  const bindCloseFrame = () => {
    if (iframeRef?.current?.contentWindow) {
      iframeRef.current.contentWindow.close = modal.close;
    }
  };

  useEffect(() => {
    setStyle({
      size: Size.LARGE,
      className: classNames(styles.gameOverlayModal, { [styles.mobile]: isMobile })
    });
  });

  return (
    <Body className={classNames(styles.modalBody)}>
      <CloseButton variant={Variant.Light} onClick={closeClick} />
      <iframe onLoad={bindCloseFrame} title={title} src={url} ref={iframeRef} />
    </Body>
  );
};

export default CasinoGameOverlay;
